// extracted by mini-css-extract-plugin
export default {"formHeaderWrapper":"ResetPassword_formHeaderWrapper__hPhQi","formTitle":"ResetPassword_formTitle__zYTiy","closeButton":"ResetPassword_closeButton__939tZ"};